export const uniqueArray = <T = {}>(
  prev: Array<T>,
  cur: Array<T>,
  key: keyof T
) => {
  return Array.from(
    new Map([...prev, ...cur].map((item) => [item[key], item])).values()
  );
};
